import React, { useState } from "react";
import PropTypes from "prop-types";
import { COLUMN_GROUPS, ALL_HIDEABLE_IDS, defaultHiddenColumns } from "./columnPrefs";

// Column picker for the pharmacy Orders table -- a copy of
// ../orders-legacy/ColumnsModal.jsx (same inline-styled shell, same reasoning for not
// using src/v2/components/Modal.jsx: this page is legacy-styled, not `--ops-*`-themed).

const CHECKBOX_CLASS =
    "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2";

function ColumnsModal({ hiddenColumns, onApply, onClose }) {
    const [draft, setDraft] = useState(() => new Set(hiddenColumns));

    const isVisible = (id) => !draft.has(id);

    const toggle = (id) =>
        setDraft((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });

    const visibleCount = ALL_HIDEABLE_IDS.length - draft.size;

    return (
        <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-[500]"
            onKeyDown={(event) => {
                if (event.key === "Escape") onClose();
            }}
            role="presentation"
        >
            <div className="w-full flex flex-col justify-center">
                <div
                    style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw", maxHeight: "80vh" }}
                    className="flex flex-col gap-4 justify-start p-4 overflow-y-auto"
                >
                    <div className="flex justify-between items-center">
                        <span className="text-2xl font-bold">Columns</span>
                        <button onClick={onClose} aria-label="Close columns">
                            ×
                        </button>
                    </div>
                    <hr />

                    <p className="text-sm text-gray-500">
                        {visibleCount} of {ALL_HIDEABLE_IDS.length} shown. Hidden columns stay in the Excel
                        download.
                    </p>

                    {COLUMN_GROUPS.map((group) => (
                        <div key={group.label} className="flex flex-col gap-2">
                            <label className="font-bold">{group.label}</label>
                            <div className="grid grid-cols-2 gap-2">
                                {group.columns.map((column) => (
                                    <label
                                        key={column.id}
                                        className="flex items-center gap-2 text-sm cursor-pointer"
                                        htmlFor={`col-${column.id}`}
                                    >
                                        <input
                                            id={`col-${column.id}`}
                                            type="checkbox"
                                            className={CHECKBOX_CLASS}
                                            checked={isVisible(column.id)}
                                            onChange={() => toggle(column.id)}
                                        />
                                        {column.label}
                                    </label>
                                ))}
                            </div>
                        </div>
                    ))}

                    <hr />
                    <div className="flex gap-3 justify-end">
                        <button
                            className="border-[1px] border-elm-500 text-elm-500 px-4 py-1 rounded-md"
                            onClick={() => setDraft(new Set(defaultHiddenColumns()))}
                        >
                            Reset to default
                        </button>
                        <button
                            className="bg-elm-500 text-white-50 px-4 py-1 rounded-md"
                            onClick={() => onApply([...draft])}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

ColumnsModal.propTypes = {
    hiddenColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
    onApply: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ColumnsModal;
